import { BaseUrl, IsLive, LogUrl } from './env.js';
import { getToken } from './jwt-cache.js';
import EventBus from './eventbus.js';
import { Constants } from '@fibl/oxs-common';
import { showErrorMessage } from './error.js';
/*
 * all requests to the server flow through here
 * this should only be called from a /repository/
 */

let backoffTimer = 0;
const backoffInterval = Constants.BACK_OFF_INTERVAL;

async function request(
	path: string,
	data: any,
	post: boolean,
	auth: string | undefined,
	surpressError?: boolean | null,
	allowEmptyPayload = false,
	allowCache = false,
	retries = 0,
): Promise<any> {
	if (!data && !allowEmptyPayload) data = {};
	if (isNaN(retries)) retries = 0;
	let url = BaseUrl + path;
	const opts: RequestInit = {};
	opts.mode = 'cors';
	opts.headers = {  };
	opts.redirect = 'follow';
	if (auth) {
		opts.headers.Authorization = `Bearer ${auth}`;
	}
	if (!post || allowCache) {
		opts.method = 'GET';
		url += '?__payload=' + JSON.stringify(data);
	} else {
		opts.method = 'POST';
		opts.body = JSON.stringify(data);
		opts.headers['Content-Type'] = 'application/json';
	}
	EventBus.emit('request.start');
	const res = await fetch(url, opts);
	EventBus.emit('request.end');
	if (res.status === 429) {
		//too many requests
		if (retries > 5) {
			const error = new Error('failed after 5 retries');
			Object.defineProperty(error, 'url', { value: url });
			// EventBus.$emit('error', error);
			throw error;
		}
		return retry(path, data, post, auth, !!surpressError, allowEmptyPayload, true, retries + 1);
	}
	try {
		const ct = res.headers.get('Content-Type');
		if (!(ct && ct.includes('application/json')))
			throw new Error(`invalid content-type was returned: ${ct}`);
		const json = await res.json();
		if (!json.ok) {
			const error: any = new Error();
			error.message = json.message ? json.message : 'unknown error';
			if (!json.message) console.error('unknown error', json);
			if (json.details) error.message += `\n - ${json.details}`;
			if (json.previous) error.previous = json.previous;
			if (json.stack) error.servicestack = json.stack;
			error.code = json.code;
			error.reqId = json.id;
			error.url = url;
			throw error;
		}
		if (backoffTimer > 0) backoffTimer -= backoffInterval;
		return json.data;
	} catch (error: any) {
		if (!surpressError && !IsLive) {
			if (!error.url) error.url = url;
			// showErrorMessage(error);
			// EventBus.$emit('error', error);
		}
		throw error;
	}
}

async function retry(
	path: string,
	data: object,
	post: boolean,
	auth: string | undefined,
	surpressError: boolean | undefined,
	allowEmptyPayload: boolean,
	allowCache: boolean,
	retries: number,
) {
	backoffTimer += backoffInterval;
	await sleep(backoffTimer);
	return request(path, data, post, auth, surpressError, allowEmptyPayload, allowCache, retries);
}

export function sleep(ms: number) {
	return new Promise(function (resolve) {
		setTimeout(resolve, ms);
	});
}

export async function get(
	path: string,
	data: any,
	auth?: string | null | false,
	supe?: boolean,
	allowCache?: boolean,
) {
	if (!auth && auth !== false) {
		auth = await getToken();
	}
	if (auth === false) auth = undefined;
	return request(path, data, false, auth, supe, false, allowCache);
}

export async function post(
	path: string,
	data: any,
	auth?: string | null | false,
	supe?: boolean | null,
	emptyPayload?: boolean,
) {
	if (!auth && auth !== false) {
		auth = await getToken();
	}
	if (auth === false) auth = undefined;
	return request(path, data, true, auth, supe, emptyPayload);
}

export function log(data: any) {
	fetch(LogUrl, {
		method: 'POST',
		headers: {
			'Content-type': 'application/json',
		},
		body: JSON.stringify(data),
	});
}
